import { structuralVariantsDbs } from "../../constants/dbs";
import Filter from "../../../../models/Filter";
import {
  pathogenicityIndex,
  pathogenicityLabelsLong,
} from "../../constants/pathogenicity";
import {
  cnvTypeIndex,
  cnvTypeLabel,
} from "../../constants/structuralVariantConstants";

function getFilters(filterCategories, maxLimit) {
  return [
    ...Object.values(structuralVariantsDbs).map(
      ({ name: label, key, hex: color }) => {
        return new Filter({
          label,
          key,
          color,
          category: filterCategories.dbCat,
        });
      }
    ),
    ...Object.values(pathogenicityIndex).map(
      (key) =>
        new Filter({
          category: filterCategories.pathCat,
          label: pathogenicityLabelsLong[key],
          key,
          value: 0,
          isVisible: false,
          totalCount: 0,
        })
    ),
    ...Object.values(cnvTypeIndex).map(
      (key) =>
        new Filter({
          category: filterCategories.typeCat,
          label: cnvTypeLabel[key],
          key,
          value: 0,
          isVisible: true,
          totalCount: 0,
        })
    ),
    new Filter({
      label: "Max Length",
      key: "maxLength",
      value: maxLimit,
      min: 1,
      max: 10000000000,
      defaultVal: maxLimit,
      isVisible: true,
      type: "number",
    }),
    new Filter({
      label: "Min Length",
      key: "minLength",
      value: 1,
      min: 1,
      max: 10000000,
      defaultVal: 1,
      isVisible: true,
      type: "number",
    }),
  ];
}

export default getFilters;
